import TurbolinksAdapter from 'vue-turbolinks';
import Vue from 'vue/dist/vue.esm';
import Datepicker from 'vuejs-datepicker';
import VueResource from 'vue-resource';
import VeeValidate from 'vee-validate';
import VueSelect from  'vue-select';
//require('vue-select/dist/vue-select.css')

// Import this component
import datePicker from 'vue-bootstrap-datetimepicker';

// Using font-awesome 5 icons

// Import date picker css
//import '/../../node_modules/pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';
Vue.use(TurbolinksAdapter);
Vue.use(VueResource);
Vue.use(VeeValidate);
Vue.component('v-select', VueSelect)

Vue.filter('formatDate', function(value) {
    if (value) {
        return moment(String(value)).format('DD/MM/YYYY')
    }
});
Vue.filter('formatTime', function(value) {
    if (value) {
        return moment(String(value)).format('LT')
    }
});
Vue.filter('formatDateTime', function(value) {
    if (value) {
        return moment(String(value)).format('DD/MM/YYYY LT')
    }
});
Vue.filter('capitalize', function (value) {
    if (!value) return '';
    value = value.toString();
    return value.charAt(0).toUpperCase() + value.slice(1)
});
Vue.filter('upcase', function (value) {
    if (!value) return '';
    value = value.toString();
    return value.toUpperCase()
});

document.addEventListener('turbolinks:load', () => {
    Vue.http.headers.common['X-CSRF-Token'] = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

    let element = document.getElementById("booking-form");
    if (element != null) {

        let id = element.dataset.id;
        let booking = JSON.parse(element.dataset.booking);


        const bookingForm = new Vue({
            el: "#booking-form",
            data() {
                return {
                    id: id,
                    booking: booking,
                    parking_options: [
                        {value: 1, text: "Short Term Outdoor Parking"},
                        {value: 2, text: "Short Term Fully Covered Parking"},
                        {value: 3, text: "Short Term Indoor Parking"},
                        {value: 4, text: "Annual Outdoor Parking"},
                        {value: 5, text: "Annual Fully Covered Parking"},
                        {value: 6, text: "Annual Indoor Parking"},
                    ],
                    car_select: [],
                    users_select:[],
                    options: {
                        format: 'h:mm',
                    },
                    cars_present: true,
                    collection: true,
                    collection_btn: false,
                    collection_text: 'Toggle collection',
                    parking_type: [],
                    parking_type_cost: null,
                    selected_car: '',
                    selected_user: '',
                    search_from: '',
                    selected_date: '',
                    discount: '',
                    step: 1,
                    minimum_booking: false,
                    //DatePickerFormat: "dd-MM-yyyy",
                    disabledDates: {
                        to:  (new Date(moment()))
                    },
                    disabledDates2: {
                        to:  (new Date(moment().add(24,'hours') - 8640000))
                    },
                    vat: '',
                    date: moment(new Date()).add(12, 'hours'),
                    minbookTime: false,
                    parking_types: this.getPrices()

                }
            },
            components: {
                Datepicker, VueSelect
            },
            methods: {
                getPrices() {
                    Rails.ajax({

                        type: 'GET',
                        dataType: 'script',
                        url: `/parking_types.json`,
                        error: function(jqXHR, textStatus, errorThrown)  {
                            console.log("AJAX Error:", textStatus)
                        },
                        //success: data => this.carList(data["cars"])
                        success: (data) =>  {
                            console.log("Parking Types!", data)
                            this.parking_types = data;
                            console.log("parking types: ", this.parking_types)
                        }
                    })
                },
                clearFromDate(){
                    this.booking.from_date = ''
                },
                clearToDate(){
                    this.booking.to_date = ''
                },
                search(queryString) {
                    this.loading = true;
                    fetch("/users_select")
                        .then(response => response.json())
                        .then(json => {
                            this.loading = false;
                            if (queryString) {
                                this.options = json.filter(user =>
                                    user.name.toLowerCase().includes(queryString.toLowerCase())
                                );
                            } else {
                                this.options = json;
                            }
                        })
                        .catch(e => {
                            console.error(e);
                            this.loading = false;
                        });
                },
                openPicker() {
                    this.$refs.datepicker.popupVisible = true
                },
                closePicker() {
                    this.$refs.datepicker.popupVisible = false
                },
                prev() {
                    this.step--;

                },
                next() {
                    this.step++;
                },
                getUsers(){
                    Rails.ajax({

                        type: 'GET',
                        dataType: 'script',
                        url: `/users_select`,
                        error: function(jqXHR, textStatus, errorThrown)  {
                            console.log("AJAX Error:", textStatus)
                        },
                        //success: data => this.carList(data["cars"])
                        success: (data) =>  {
                            let users = data["users"];
                            if (users.length ){
                                for (var i = 0; i < users.length; i++) {

                                    var option = {
                                        value: users[i][0],
                                        label: users[i][1]
                                    }
                                    this.userList(option)
                                }

                            } else {
                                var newUser = {
                                    value: null,
                                    text: "No users available"
                                }
                                this.userList(newUser)
                                alert("No users available.")
                            }

                        }
                    })
                },
                userList(usersObject){
                    this.users_select.push(usersObject)
                },
                getUserCars(){
                    this.car_select = []
                    this.booking.car_id = ''

                    let user_id = this.booking.user_id
                    //let carSelect = []
                    Rails.ajax({

                        type: 'GET',
                        dataType: 'script',
                        url: `/cars_by_user/${user_id}`,
                        error: function(jqXHR, textStatus, errorThrown)  {
                            console.log("AJAX Error:", textStatus)
                        },
                        //success: data => this.carList(data["cars"])
                        success: (data) =>  {
                            console.log("Dynamic operator select OK!", data)
                            let cars = data["cars"];
                            console.log("cars: ", cars)
                            //this.booking.car_id = ''
                            //this.booking.user_id = ''
                            for (var i = 0; i < cars.length; i++) {

                                var newCar = {
                                    value: cars[i]["id"],
                                    text: (cars[i]["make"] + ' ' + cars[i]["model"] + ' ' + cars[i]["registration"])
                                }
                                this.carList(newCar)
                            }

                            if (cars.length ){


                            } else {
                                var newCar = {
                                    value: null,
                                    text: "No cars available"
                                }
                                this.carList(newCar)
                                alert("No cars available create a new car")
                            }

                        }
                    })
                    //this.selected_user = this.
                    //this.savedUser()

                },

                carList(carsObject){

                    this.car_select.push(carsObject)
                },
                costDaily() {
                    if(this.parking_type.value === 1){
                        this.booking.parking_type_id = 1
                        this.parking_type_cost = parseFloat(this.parking_types[0]['day_price']).toFixed(2)
                        this.collection_btn = false
                        this.booking.duration = ''
                        this.discount = ''
                    }
                    else if(this.parking_type.value === 2){
                        this.booking.parking_type_id = 2
                        this.parking_type_cost = parseFloat(this.parking_types[1]['day_price']).toFixed(2)
                        this.collection_btn= false
                        this.booking.duration = ''
                        this.discount = ''
                    }
                    else if(this.parking_type.value === 3){
                        this.booking.parking_type_id = 3
                        this.parking_type_cost = parseFloat(this.parking_types[2]['day_price']).toFixed(2)
                        this.collection_btn= false
                        this.booking.duration = ''
                        this.discount = ''
                    }
                    this.checkSameDay()
                    this.totalCost()

                },
                afterStartDate() {
                    console.log("from date",this.booking.from_date, "from time",this.booking.from_time)
                    let startDate  = moment(moment(this.booking.from_date))
                    console.log(startDate)
                    if (moment(this.booking.from_date).isBefore(moment(startDate).add(12, 'hours'))){
                        //this.booking.from_date = moment()
                        alert('Please choose a date that is not in the past.')
                        this.booking.from_date = '';
                        // moment(this.booking.from_date).isSame(moment().startOf('day')) &&
                    }
                    else
                        this.booking.to_date != null
                    this.checkSameDay()
                    this.totalDays()
                },
                checkSameDay(){
                    if(this.booking.from_date !=null && moment(this.booking.from_date).isSame(moment(), 'day')){
                        this.minbookTime = true
                        this.minimum_booking = true
                        console.log("From date:",this.booking.from_date)
                        this.booking.from_date =  moment(this.booking.from_date).add(12,'hours').format('DD/MM/YYYY')
                        console.log("From date:",this.booking.from_date)
                        //this.disabledDates2 = (new Date(moment().add(36, 'hours')  - 8640000))
                        this.booking.from_time = moment().add(13, 'hours').startOf('hour').format('hh:mm A')
                        console.log("fromtime ", this.booking.from_time)
                        this.removeWarnings()

                        //this.closePicker()
                    } else {
                        this.minbookTime = false
                        this.minimum_booking = false

                    }
                    this.disabledDates2 = {
                        to:  (new Date(moment(this.booking.from_date).add(24,'hours') - 8640000))
                    }
                    this.checkFromTime()
                    this.totalDays()

                },
                checkParkingType(){
                    if (this.booking.parking_type_id == null){
                        alert('Please select parking type')
                    }
                },
                checkFromTime(){
                    console.log(moment())
                    if (this.booking.from_date != null && this.booking.from_time != null &&(moment(this.booking.from_date).isSame(moment(), 'day') || moment(this.booking.from_date).isSame(moment().add(12,'hours'), 'day'))){
                        console.log("from time first", this.booking.from_time)
                        this.booking.from_time = moment(this.booking.from_time, "hh:mm A").add(12, 'hours')
                        console.log("from time", this.booking.from_time)
                        const start = moment();
                        console.log("start",start)
                        const minbook = moment(start).add(13, "hours").startOf('hour').format('hh:mm A')
                        console.log("minbook",minbook)
                        var from_time = moment(this.booking.from_time).format('hh:mm A')
                        console.log("from time var",from_time)
                        if( from_time < minbook){
                            this.booking.from_time = minbook
                            //this.booking.from_time = new Date(moment(this.booking.from_time, 'hh:mm A').format('hh:mm A'))
                            console.log("from time if less than min", this.booking.from_time)
                            console.log("less than min book")
                            this.minbookTime = true
                            this.minimum_booking = true
                            this.removeWarnings()
                            console.log("booking from time", this.booking.from_time)

                        }
                        else{
                            this.minbookTime = false
                            this.minimum_booking = false
                            this.booking.from_time = moment(this.booking.from_time).format('hh:mm A').toString()
                            console.log("Not less than min book")
                        }
                        this.totalDays()

                    }
                },
                removeWarnings() {
                    setTimeout( () =>{
                        this.minbookTime = false
                        this.minimum_booking = false
                    }, 3000);
                },
                checkToday(){
                    if(moment(this.booking.from_date, 'DD/MM/YYY').isSame(moment(), 'day')){
                        alert("Please call us on +34 951 332 805 if the drop off time is less than 24 hours ahead. ")
                        this.minimum_booking = true
                        this.minbookTime = true
                        this.booking.from_date =  moment(this.booking.from_date, 'DD/MM/YYYY').add(1, 'day').format('DD/MM/YYYY')
                    } else {
                        this.minimum_booking = false
                        this.minbookTime = false
                    }
                },
                checkToDate() {

                    if (moment(this.booking.to_date).isBefore(moment(this.booking.from_date) )||moment(this.booking.from_date).isSame(moment(this.booking.to_date), 'day')){
                        alert("The collection date must at least 1 day after the drop off date.")
                        console.log('from date after or same as to date')
                        //this.booking.to_date = moment(this.booking.from_date).add(1,'days')
                        this.booking.to_date= '';
                    }
                    else if (this.booking.from_date ==null){
                        alert("First add a dropoff date.")
                        this.booking.to_date = '';
                        this.openPicker()
                        console.log( 'Any time fine')
                    }
                    else{
                        console.log('Any time fine')
                    }
                    this.checkSameDay()
                    this.totalDays()
                },
                rangeSearch() {
                    if ( this.booking.from_date > this.booking.to_date){

                        alert("The collection date must at least 1 day after the drop off date.")
                        console.log('from date after to date')
                        this.booking.to_date = '';
                        //this.booking.to_date = moment(this.booking.from_date).add('3', 'days')
                    }
                    else if(moment(this.booking.from_date).isSame(moment(booking.to_date), 'day')){
                        alert("Please call us on +34 951 332 805 if the drop off time is less than 24 hours ahead. ")
                        this.booking.to_date = '';
                    }
                    else {

                        if (this.booking.from_date != null && this.booking.to_date != null) {
                            let a = moment(this.booking.from_date, "DD/MM/YYYY");
                            let b = moment(this.booking.to_date);
                            //this.booking.to_date - this.booking.from_date;
                            let duration = b.diff(a, 'days');
                            this.booking.duration = duration
                            this.discount = ''

                        }
                        else {
                            console.log('Inputs Empty')
                        }
                    }

                },
                savedCar(){

                    let carArray = this.selected_car.text.split(" ")
                    //console.log(carArray.join(' ').split(' ').filter(Boolean));
                    let first = carArray.shift();
                    let second = carArray.shift();
                    let third = carArray.shift();

                    console.log(carArray)
                    this.booking.car_id = this.selected_car.id
                    this.booking.car_make = first;
                    this.booking.car_model = second;
                    this.booking.car_registration = third;

                },
                savedUser(){
                    let user = this.selected_user.text.split(" ")
                    //console.log(carArray.join(' ').split(' ').filter(Boolean));
                    let first = userArray.shift();
                    let second = userArray.shift();
                    let third = userArray.shift();
                    let forth = userArray.shift();
                    this.booking.user_id = parseInt(first)
                    this.booking.name = second;
                    this.booking.email = third;
                    this.booking.phone = forth;
                },
                totalDays() {
                    //this.booking.from_date = moment(this.booking.from_date, "DD/MM/YYYY").format("DD/MM/YYYY")
                    //this.booking.to_date = moment(this.booking.to_date)
                    if (this.booking.from_date != null && this.booking.to_date != null) {
                        let a = moment(this.booking.from_date, "DD/MM/YYYY");
                        let b = moment(this.booking.to_date);
                        //this.booking.to_date - this.booking.from_date;
                        // let duration = b.diff(a, 'days');
                        let duration = (b.diff(a, 'days'))+1;

                        this.booking.duration = duration

                        this.discount = ''
                        this.totalCost()

                    }
                    else {
                        console.log('Inputs Empty')
                    }
                },
                totalCost() {

                    if (this.booking.duration != null) {

                        if (this.booking.duration <= 3 && this.parking_type.value === 1) {

                            this.booking.price = parseFloat(this.parking_types[5]['price_three']).toFixed(2)

                        }
                        else if (this.booking.duration <= 3 && this.parking_type.value === 2) {

                            this.booking.price = parseFloat(this.parking_types[4]['price_three']).toFixed(2)
                        }
                        else if (this.booking.duration <= 3 && this.parking_type.value === 3) {

                            this.booking.price = parseFloat(this.parking_types[3]['price_three']).toFixed(2)
                        }
                        else if (this.booking.duration == 4 && this.parking_type.value === 1) {

                            this.booking.price = parseFloat(this.parking_types[5]['price_four']).toFixed(2)
                        }
                        else if (this.booking.duration == 4 && this.parking_type.value === 2) {

                            this.booking.price = parseFloat(this.parking_types[4]['price_four']).toFixed(2)
                        }
                        else if (this.booking.duration == 4 && this.parking_type.value === 3) {

                            this.booking.price = parseFloat(this.parking_types[3]['price_four']).toFixed(2)
                        }
                        else if (this.booking.duration == 5 && this.parking_type.value === 1) {

                            this.booking.price = parseFloat(this.parking_types[5]['price_five']).toFixed(2)
                        }
                        else if (this.booking.duration == 5 && this.parking_type.value === 2) {

                            this.booking.price = parseFloat(this.parking_types[4]['price_five']).toFixed(2)
                        }
                        else if (this.booking.duration == 5 && this.parking_type.value === 3) {

                            this.booking.price = parseFloat(this.parking_types[3]['price_five']).toFixed(2)
                        }
                        else if (this.booking.duration == 6 && this.parking_type.value === 1) {

                            this.booking.price = parseFloat(this.parking_types[5]['price_six']).toFixed(2)
                        }
                        else if (this.booking.duration == 6 && this.parking_type.value === 2) {

                            this.booking.price = parseFloat(this.parking_types[4]['price_six']).toFixed(2)
                        }
                        else if (this.booking.duration == 6 && this.parking_type.value === 3) {

                            this.booking.price = parseFloat(this.parking_types[3]['price_six']).toFixed(2)
                        }
                        else if (this.booking.duration == 7 && this.parking_type.value === 1) {

                            this.booking.price = parseFloat(this.parking_types[5]['price_seven']).toFixed(2)
                        }
                        else if (this.booking.duration == 7 && this.parking_type.value === 2) {

                            this.booking.price = parseFloat(this.parking_types[4]['price_seven']).toFixed(2)
                        }
                        else if (this.booking.duration == 7 && this.parking_type.value === 3) {

                            this.booking.price = parseFloat(this.parking_types[3]['price_seven']).toFixed(2)
                        }
                        else if (this.booking.duration > 7 && this.booking.duration < 30 && this.parking_type.value === 1){
                            this.booking.price = parseInt(this.booking.duration - 7)  *  parseFloat(this.parking_types[5]['day_price']) + parseFloat(42.00)
                        }
                        else if (this.booking.duration > 7 && this.booking.duration < 30 && this.parking_type.value === 2){
                            this.booking.price = parseInt(this.booking.duration - 7)  * parseFloat(this.parking_types[4]['day_price']) + parseFloat(54.00)
                        }
                        else if (this.booking.duration > 7 && this.booking.duration < 30 && this.parking_type.value === 3){
                            this.booking.price = parseInt(this.booking.duration - 7)  * parseFloat(this.parking_types[3]['day_price']) + parseFloat(58.30)
                        }
                        else if (this.booking.duration >= 30 && this.booking.duration <= 89 && this.parking_type.value === 1){

                            this.booking.price = parseInt(this.booking.duration - 30)  * parseFloat(this.parking_types[5]['day_price']) + parseFloat(88.00)
                            this.discount = '1 Month discount applied'
                            console.log(this.booking.duration, '>30 <=60')
                        }
                        else if (this.booking.duration >= 30 && this.booking.duration <= 89 && this.parking_type.value === 2){
                            this.booking.price = parseInt(this.booking.duration - 30)  * parseFloat(this.parking_types[4]['day_price']) + parseFloat(99.00)
                            this.discount = '1 Month discount applied'
                        }
                        else if (this.booking.duration >= 30 && this.booking.duration <= 89 && this.parking_type.value === 3){
                            this.booking.price = parseInt(this.booking.duration - 30)  * parseFloat(this.parking_types[3]['day_price']) + parseFloat(135.00)
                            this.discount = '1 Month discount applied'
                        }
                        else if (this.booking.duration >= 90  && this.booking.duration <= 179 && this.parking_type.value === 1){

                            this.booking.price = parseInt(this.booking.duration - 90)  * parseFloat(this.parking_types[5]['day_price']) + parseFloat(255.00)
                            console.log(this.booking.duration, '>=90 <=120')
                            this.discount = '3 month discount applied'
                        }
                        else if (this.booking.duration >= 90  && this.booking.duration <= 179 && this.parking_type.value === 2){
                            this.booking.price = parseInt(this.booking.duration - 90)  * parseFloat(this.parking_types[4]['day_price']) + parseFloat(275.00)
                            this.discount = '3 month discount applied'
                        }
                        else if (this.booking.duration >= 90 && this.booking.duration <= 179 && this.parking_type.value === 3){
                            this.booking.price = parseInt(this.booking.duration - 90)  * parseFloat(this.parking_types[3]['day_price']) + parseFloat(385.00)
                            this.discount = '3 month discount applied'
                        }
                        else if (this.booking.duration >= 180 && this.booking.duration <= 364 && this.parking_type.value === 1){

                            this.booking.price = parseInt(this.booking.duration - 180)  * parseFloat(this.parking_types[5]['day_price']) + parseFloat(380.00)
                            console.log(this.booking.duration, '>=180 <=365')
                            this.discount = '6 month discount applied'
                        }
                        else if (this.booking.duration >= 180  && this.booking.duration <= 364 && this.parking_type.value === 2){
                            this.booking.price = parseInt(this.booking.duration - 180)  * parseFloat(this.parking_types[4]['day_price']) + parseFloat(495.00)
                            this.discount = '6 month discount applied'
                        }
                        else if (this.booking.duration >= 180 && this.booking.duration <= 364 && this.parking_type.value === 3){
                            this.booking.price = parseInt(this.booking.duration - 180)  * parseFloat(this.parking_types[3]['day_price']) + parseFloat(655.00)
                            this.discount = '6 month discount applied'
                        }
                        else if (this.booking.duration >= 365 && this.parking_type.value === 1){

                            this.booking.price = parseInt(this.booking.duration - 365)  * parseFloat(this.parking_types[5]['day_price']) + parseFloat(625.00)
                            this.discount = '1 Year discount applied'

                        }
                        else if (this.booking.duration >= 365 && this.parking_type.value === 2){
                            this.booking.price = parseInt(this.booking.duration - 365)  * parseFloat(this.parking_types[4]['day_price']) + parseFloat(799.00)
                            this.discount = '1 Year discount applied'
                        }
                        else if (this.booking.duration >= 365 && this.parking_type.value === 3){
                            this.booking.price = parseInt(this.booking.duration - 365)  * parseFloat(this.parking_types[3]['day_price']) + parseFloat(1095.00)
                            this.discount = '1 Year discount applied'
                        }
                    }
                    if(this.parking_type.value === 4) {
                        this.booking.price = parseFloat(this.parking_types[3]['price_yearly'])
                        this.booking.duration = 365
                        this.collection_btn = true
                        this.booking.annual = true
                        this.discount = '1 Year discount applied'
                        this.booking.parking_type_id = 4
                        //this.collection_text = "Add Collection Date Later?"
                        console.log(this.collection_btn, "Option 4")
                        this.toggleSeen()

                    }
                    if(this.parking_type.value === 5) {
                        this.booking.price = parseFloat(this.parking_types[4]['price_yearly'])
                        this.booking.duration = 365
                        this.collection_btn = true
                        this.booking.annual = true
                        this.discount = '1 Year discount applied'
                        this.booking.parking_type_id = 5
                        //this.collection_text = "Add Collection Date"
                        this.toggleSeen()

                        console.log(this.collection_btn, "Option 5")
                    }
                    if(this.parking_type.value === 6) {
                        this.booking.price = parseFloat(this.parking_types[5]['price_yearly'])
                        this.booking.duration = 365
                        this.collection_btn = true
                        this.booking.annual = true
                        this.discount = '1 Year discount applied'
                        this.booking.parking_type_id = 6
                        //this.collection_text = "Add Collection Date Later?"
                        console.log(this.collection_btn, "Option 6")
                        this.toggleSeen()
                    }
                    // console.log(this.booking.duration + ' ' + "PRICE=" + this.booking.price)
                    this.calcVat()
                    // console.log(this.booking.vat)

                },
                calcVat(){
                    this.booking.vat = this.booking.price * 0.21
                },

                scrollTop() { {
                    var element = document.getElementById("booking-form");
                    var top = element.offsetTop;
                    window.scrollTo(0, -50);
                    console.log('scroll')
                }
                },
                customFormatter(date) {
                    return moment(date).format('DD/MM/YYYY');
                },
                validateForm(scope){
                    this.$validator.validateAll(scope).then((result) => {
                        if (result) {
                            this.scrollTop();
                            this.step++;
                            return;
                        }
                        // eslint-disable-next-line

                    });
                },
                submit(scope) {
                    this.validateForm(scope)
                    // Create a new booking
                    if (this.id == null) {
                        this.$http.post('/bookings', {booking: this.booking}).then(response => {
                            Turbolinks.visit(`/bookings/${response.body.id}`)
                        }, response => {
                            // console.log(response)
                        })
                        // Edit an existing booking
                    } else {
                        this.$http.put(`/bookings/${this.id}`, {booking: this.booking}).then(response => {
                            Turbolinks.visit(`/bookings/${response.body.id}`)
                        }, response => {
                            // console.log(response)
                        })
                    }
                },
                toggleSeen: function() {
                    element.collection = !element.collection;
                    element.collection_text = element.collection ? 'Add Collection Date Later' : 'Add Collection Date Now';
                },
                existingBooking: function() {
                    return this.booking.id != null
                },
                updateVal(value) {
                    this(value)
                },
                formatPrice(value) {
                    let val = (value/1).toFixed(2).replace('.', ',')
                    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
                },





            },
            computed: {
                fromTime() {
                    return moment(booking.from_time).format('h:mm A');
                },
                //toTime(value) {
                //    if (value) {
                //        return this.booking.to_time = moment(String(value)).format('LT')
                //    }
                //},

                timeFormat(time){
                    time = moment(time, 'LT')
                },
                collectionText(){
                    if (this.collection == true){
                        return this.collection_text = "Add Collection Date Later?"
                    } else{
                        return this.collection_text = "Add Collection date?"
                    }
                }
            },


            beforeMount: function() {
                this.$originalElement = this.$el
                //this.getUsers()
            },
            destroyed: function() {
                this.$el = this.$originalElement
            }
        });
        document.addEventListener('turbolinks:before-cache', () => {
            bookingForm.$destroy()
        })
    }

});
